/* unplugin-vue-components disabled */import { render } from "./icon_nav_menu.vue?vue&type=template&id=bcdc95d8&scoped=true"
const script = {}

import "./icon_nav_menu.vue?vue&type=style&index=0&id=bcdc95d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcdc95d8"]])

export default __exports__